import styled from "styled-components";

export const ContainerWithBG = styled.div`
	display: flex;
	width: 100%;
	height: calc(100vh - 70px);
	min-height: 450px;
	background-image: url(${props => props.backgroundImageUrl});
	background-position-y: 59%;
	background-size: 100%;
	justify-content: center;
	align-items: center;
	overflow: hidden;

	@media only screen and (max-width: 940px) {
		background-position-x: 50%;
		overflow: hidden;
		background-size: 130%;
	}
`;

export const RoundedContainer = styled.div`
	background-color: #ffffffaa;
	-webkit-backdrop-filter: blur(10px);
	backdrop-filter: blur(10px);
	border-radius: 40px;
	padding: 20px;
	padding: ${props => props.$padding};
	transform: rotateY(0deg) translate(0px);
	margin: ${props => props.$margin};
`;
